import React from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

/**
 * One consent box: a large tap target with the choice's title and its exact
 * wording (from the API, so what's shown is what gets recorded). Never ticked
 * in advance.
 */
export default function ConsentChoice({
  title,
  text,
  checked,
  onChange,
  disabled,
  badge,
}) {
  return (
    <label
      className={`flex cursor-pointer gap-3 rounded-xl border p-4 transition-colors duration-150 ${
        checked
          ? "border-[#E07A3A] bg-[#FFF8F3]"
          : "border-[#E5E7EB] bg-white hover:border-[#D1D5DB]"
      } ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
    >
      <input
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span
        aria-hidden="true"
        className={`mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-md border-2 transition-colors duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-[#E07A3A] peer-focus-visible:ring-offset-2 ${
          checked
            ? "border-[#E07A3A] bg-[#E07A3A] text-white"
            : "border-[#D1D5DB] bg-white"
        }`}
      >
        {checked && <Check size={14} strokeWidth={3} />}
      </span>
      <span className="min-w-0">
        <span className="flex flex-wrap items-center gap-2 text-[15px] font-semibold text-[#111827]">
          {title}
          {badge}
        </span>
        {text && (
          <span className="mt-1 block text-sm leading-relaxed text-[#6B7280]">
            {text}
          </span>
        )}
      </span>
    </label>
  );
}

/** "Required" or "Optional", next to a consent choice's title. */
export function RequiredTag({ required }) {
  const { t } = useTranslation();
  return (
    <span
      className={`rounded px-1.5 py-0.5 text-[11px] font-semibold ${
        required ? "bg-[#FFF1E8] text-[#C2410C]" : "bg-[#F3F4F6] text-[#6B7280]"
      }`}
    >
      {required
        ? t("auth.guardianSignup.tags.required")
        : t("auth.guardianSignup.tags.optional")}
    </span>
  );
}
